export default "__VITE_ASSET__c254972a__"